import isNaN from 'lodash/isNaN';
import isNil from 'lodash/isNil';
export default function isValidNumber(value) {
  return !isNil(value) && !isNaN(value) && value !== 'NaN' && value !== Infinity && value !== -Infinity && value !== 'Infinity' && value !== '-Infinity';
}